import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS (modern, softer neutrals)
const GREY = {
  0: '#FFFFFF',
  50: '#F8FAFC',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827',
};

// Vibrant yet professional accent (blue)
const PRIMARY = {
  lighter: '#DBEAFE',
  light: '#93C5FD',
  main: '#3B82F6',
  dark: '#1D4ED8',
  darker: '#1E40AF',
  contrastText: '#FFFFFF',
};

// Complementary accent (violet)
const SECONDARY = {
  lighter: '#EDE9FE',
  light: '#C4B5FD',
  main: '#8B5CF6',
  dark: '#6D28D9',
  darker: '#5B21B6',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#E0F2FE',
  light: '#7DD3FC',
  main: '#0EA5E9',
  dark: '#0369A1',
  darker: '#075985',
  contrastText: '#FFFFFF',
};

const SUCCESS = {
  lighter: '#DCFCE7',
  light: '#86EFAC',
  main: '#22C55E',
  dark: '#16A34A',
  darker: '#166534',
  contrastText: GREY[900],
};

const WARNING = {
  lighter: '#FEF3C7',
  light: '#FCD34D',
  main: '#F59E0B',
  dark: '#D97706',
  darker: '#92400E',
  contrastText: GREY[900],
};

const ERROR = {
  lighter: '#FEE2E2',
  light: '#FCA5A5',
  main: '#EF4444',
  dark: '#DC2626',
  darker: '#991B1B',
  contrastText: '#FFFFFF',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[400], 0.24),
  text: {
    primary: GREY[900],
    secondary: GREY[600],
    disabled: GREY[400],
  },
  background: {
    paper: '#FFFFFF',
    default: GREY[50],
    neutral: GREY[100],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.14),
    disabled: alpha(GREY[400], 0.8),
    disabledBackground: alpha(GREY[300], 0.32),
    focus: alpha(PRIMARY.main, 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
